<template>
  <el-breadcrumb class="nav-bread" separator-class="newhope-iconfont icon-base-right">
    <template v-for="item in breadData">
      <el-breadcrumb-item @click.native="() => navClick(item)" :key="item.id" v-if="item.path" :to="{ path: item.path }">
        {{item.title}}
      </el-breadcrumb-item>
      <el-breadcrumb-item :key="item.id" v-else>
        {{item.title}}
      </el-breadcrumb-item>
    </template>
    <el-breadcrumb-item>{{activeTab.title}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'navBread',
  data() {
    return {
    }
  },
  methods: {
    expandTree(treeData) {
      this.breadData.push(treeData)
      if (treeData.children?.length) {
        treeData.children.forEach(item => {
          this.expandTree(item)
        })
      }
    },
    navClick(item) {
      if (this.$route.path !== item.path) {
        this.$router.push({
          path: item.path
        })
      }
    }
  },
  computed: {
    ...mapState('systemMenu', ['menuList', 'activeTab']),
    expandData() {
      const array = []
      function loop(tree, parentIds) {
        const { children, ...parentProps } = tree
        if (children?.length) {
          tree.children.forEach(child => {
            // eslint-disable-next-line no-unused-vars
            const { children, ...otherProps } = child
            const myParents = parentProps.id ? [...parentIds, parentProps.id] : [...parentIds]
            array.push({
              ...otherProps,
              parentIds: myParents
            })
            loop(child, myParents)
          })
        }
      }
      loop({
        children: this.menuList
      }, [])
      return array
    },
    breadData() {
      const parentIds = this.expandData.find(item => {
        return item.id === this.activeTab.id
      })?.parentIds || []
      return parentIds.map(id => {
        const item = this.expandData.find(parent => {
          return parent.id === id
        }) || {}
        return {
          ...item,
          allChildren: this.expandData.filter(child => {
            return child.parentIds.includes(item.id)
          }).map(child => {
            return child.id
          })
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.nav-bread {
  background-color: $color-bg;
  padding: 0 0 10px;
  font-size: 14px;
  display: flex;
  align-items: center;

  ::v-deep .el-breadcrumb__item {
    display: flex;
    align-items: center;

    .el-breadcrumb__inner {
      display: flex;
      align-items: center;
    }

    .el-breadcrumb__separator {
      display: flex;
      align-items: center;
      margin-top: 0;
      margin-bottom: 0;
    }

    &:last-child {
      .el-breadcrumb__separator {
        display: none;
      }
    }
  }
}
</style>
